import { useState } from 'react';
import { Flex, Tooltip } from 'antd';
import { useFilterContext, useDerivedNetworkContext } from '@/context';
import { DownloadButtonEcho } from '@/components/drawers/DownloadButton/DownloadButtonEcho';
import { TextTooltipContentEcho } from '@/components/tooltips/TextTooltipEcho';
import useNewDownloadDrawersEnabled from '@/hooks/useNewDownloadDrawersEnabled';
import { AUDIENCE_PAGE } from '@/utils/constants';
import { mixpanelTrack } from '@/utils/mixpanelUtils/asyncMixpanel';
import { MIXPANEL_EVENT, RevenueDashboardWidget } from '@/utils/mixpanelUtils/events';
import AudienceDownloadDrawer from './AudienceDownloadDrawer';

/**
 * Opens the audience CSV download drawer when the new download drawers flag is on.
 * Otherwise the button stays disabled with the coming-soon tooltip.
 */
const AudienceDownloadTriggerEcho = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isNewDownloadDrawerEnabled = useNewDownloadDrawersEnabled();
  const { selectedNetwork, shows } = useDerivedNetworkContext();
  const { filters } = useFilterContext();

  if (!isNewDownloadDrawerEnabled) {
    return (
      <Tooltip
        placement="bottom"
        title={
          <TextTooltipContentEcho
            title="Coming soon"
            description="We are working on this at the moment."
          />
        }
      >
        <Flex>
          <DownloadButtonEcho disabled onClick={() => {}} />
        </Flex>
      </Tooltip>
    );
  }

  const handleOpen = () => {
    setIsOpen(true);
    mixpanelTrack(MIXPANEL_EVENT.audience.downloadDrawer.opened, {
      widget: RevenueDashboardWidget.AudienceDownloadDrawer,
      page: AUDIENCE_PAGE,
    });
  };

  return (
    <>
      <DownloadButtonEcho onClick={handleOpen} />
      {isOpen && (
        <AudienceDownloadDrawer
          isOpen={isOpen}
          handleClose={() => setIsOpen(false)}
          selectedNetwork={selectedNetwork}
          globalFilters={filters}
          shows={shows}
        />
      )}
    </>
  );
};

export default AudienceDownloadTriggerEcho;
